import Swal from "sweetalert2";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import { useChatStore } from "../../stores/ChatStore";
import { useIntl } from "react-intl";
import { clearDB, clearDBExceptIncomingMessageNotifications } from "../../db";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { deleteSessionChat } from "../../api/ChatCRUD";
import useAccessToken from "../../hooks/AccessToken";
import { ListChatPhone } from "../../interfaces/Chat/ListChatPhone";
import { chatMode } from "../../functions/chat";
import { useSettingsStore } from "../../stores/SettingsStore";

const ChatAside = () => {
    const intl = useIntl()
    const token = useAccessToken()
    const { settings } = useSettingsStore()

    const { menuActive, setMenuActive, tokenChat, selectedChatPhone, setTokenChat, setConnected, setSelectedChatPhone } = useChatStore()
    const listTopMenu = [
        {
            id: "dashboard",
            name: "Dashboard",
            icon: <img src={toAbsoluteUrl('/media/logos/logo-wooblazz-border.png')} className='symbol symbol-45px img-fluid mb-2' alt='profile' style={{ width: "30px" }} />,
            to: "/dashboard"
        },
        {
            id: "chat",
            name: intl.formatMessage({ id: "FORM.LABEL.CHAT" }),
            icon: <i className="fas fa-comment-dots fs-1 menu-icon text-white"></i>,
            to: "list"
        },
        {
            id: "chat-group",
            name: intl.formatMessage({ id: "FORM.LABEL.GROUP_CHAT" }),
            icon: <i className="fas fa-comments fs-1 menu-icon text-white"></i>,
            to: "list-group"
        },
        {
            id: "settings",
            name: intl.formatMessage({ id: "MENU.SETTING" }),
            icon: <i className="fas fa-cog fs-1 menu-icon text-white"></i>,
            to: "settings"
        },
        {
            id: "analytics",
            name: intl.formatMessage({ id: "MENU.ANALYTICS"}),
            icon: <i className="fas fa-chart-line fs-1 menu-icon text-white"></i>,
            to: "analytics"
        },
    ]

    const listBottomMenu = [
        {
            id: "info",
            name: "Info",
            icon: <i className="fas fa-info-circle fs-1 menu-icon text-white"></i>,
            to: ""
        },
        {
            id: "refresh",
            name: "Refresh Data",
            icon: <i className="fas fa-sync-alt fs-1 menu-icon text-white"></i>,
            to: ""
        },
        {
            id: "logout",
            name: intl.formatMessage({ id: "FORM.ACTION.LOG_OUT" }),
            icon: <i className="fas fa-sign-out-alt fs-1 menu-icon text-white"></i>,
            to: ""
        },
    ]

    const handleRefresh = () => {
        Swal.fire({
            title: intl.formatMessage({ id: "ALERT.TITLE.REFRESH_CHAT" }),
            text: intl.formatMessage({ id: "ALERT.TEXT.REFRESH_CHAT" }),
            icon: "question",
            showCancelButton: !0,
            buttonsStyling: !1,
            confirmButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.YES" }),
            cancelButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.NO" }),
            showLoaderOnConfirm: true,
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-active-light me-3',
            },
            reverseButtons: true,
            heightAuto: false,
            preConfirm: async () => {
                await clearDBExceptIncomingMessageNotifications()
                const updateSelectedChatPhone = selectedChatPhone.map((item: ListChatPhone, index: number) => ({
                    ...item,
                    lastSycned: null,
                    newDateChat: null,
                    oldDateChat: null
                }))
                setSelectedChatPhone(() => updateSelectedChatPhone)
                window.location.reload()
            },
        })
    }

    const handleLogoutChat = () => {
        Swal.fire({
            title: intl.formatMessage({ id: "ALERT.TITLE.LOG_OUT" }),
            text: intl.formatMessage({ id: "ALERT.TEXT.LOG_OUT" }),
            icon: "warning",
            showCancelButton: true,
            buttonsStyling: false,
            confirmButtonText: intl.formatMessage({ id: "FORM.ACTION.LOG_OUT" }),
            cancelButtonText: intl.formatMessage({ id: "FORM.CONFIRMATION.NO" }),
            showLoaderOnConfirm: true,
            customClass: {
                confirmButton: 'btn btn-danger',
                cancelButton: 'btn btn-active-light',
            },
            reverseButtons: true,
            heightAuto: false,
            preConfirm: async () => {
                try {
                    const response = await deleteSessionChat(
                        selectedChatPhone[0].phone,
                        chatMode(settings.chat_version),
                        token,
                        tokenChat
                    );

                    if (response.data.success) {
                        await clearDB(); // Pastikan selesai
                        setConnected(() => false);
                        setTokenChat(() => "");
                        return true; // Tandai sukses
                    } else {
                        throw new Error("Gagal logout");
                    }
                } catch (error: any) {
                    Swal.fire({
                        icon: 'error',
                        title: error.response?.data?.message || 'Terjadi kesalahan',
                        confirmButtonText: 'Ok',
                    });
                    return false;
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                // Reload baru dijalankan setelah Swal selesai dan clearDB dijamin sudah selesai
                window.location.reload();
            }
        });
    };

    return (
        <div className='card card-flush py-5 justify-content-between' style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", width: "70px", backgroundColor: "#50cd89", borderTopLeftRadius: "inherit", borderBottomLeftRadius: "inherit", position: 'relative' }}>
            <div className="d-flex flex-column gap-4">
                {
                    listTopMenu.map((item, index) => {
                        return (
                            <div key={item.id} className={`menu-icon cursor-pointer align-self-center`} onClick={() => item.id === "dashboard" ? window.location.href = item.to : setMenuActive(item.id)}>
                                <OverlayTrigger
                                    placement='right'
                                    overlay={
                                        <Tooltip id='tooltip-labels'>
                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {item.name}
                                            </span>
                                        </Tooltip>}
                                >
                                    <span
                                        id={`menu-${index}`}
                                        className='cursor-pointer'
                                        data-toggle='tooltip'
                                        data-placement='right'
                                        title=''
                                        style={menuActive === item.id ? { padding: "5px", backgroundColor: "rgba(255, 255, 255, 0.3)", borderRadius: "5px", display: 'flex' } : {}}
                                    >
                                        {item.icon}
                                    </span>
                                </OverlayTrigger>
                            </div>
                        )
                    })
                }
            </div>
            <div className="d-flex flex-column gap-3" style={{ position: 'sticky', bottom: 10 }}>
                {
                    listBottomMenu.map((item, index) => {
                        return (
                            <div key={item.id} className={`menu-icon cursor-pointer align-self-center`} onClick={(e) => item.id === 'refresh' ? handleRefresh() : item.id === 'logout' ? handleLogoutChat() : e.stopPropagation()}>
                                <OverlayTrigger
                                    placement='right'
                                    overlay={
                                        <Tooltip id='tooltip-labels'>
                                            {
                                                item.id === 'info' ?
                                                    <>
                                                        {
                                                            selectedChatPhone.map((item, index) => {
                                                                return (
                                                                    <div className={`${selectedChatPhone.length > 1 && 'mb-2'} text-start`} key={index}>
                                                                        <span className="d-flex align-items-center gap-2">
                                                                            {
                                                                                selectedChatPhone.length > 1 && <span className="bullet bullet-dot h-10px w-10px" style={{ backgroundColor: item.color }}></span>
                                                                            }
                                                                            <b>{item.phone}</b>
                                                                        </span>
                                                                        <span className="text-start d-block">{item?.ownersName.join(', ')}</span>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </>
                                                    :
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {item.name}
                                                    </span>
                                            }
                                        </Tooltip>}
                                >
                                    <span
                                        id={`menu-${index}`}
                                        className='cursor-pointer'
                                        data-toggle='tooltip'
                                        data-placement='right'
                                        title=''
                                    >
                                        {item.icon}
                                    </span>
                                </OverlayTrigger>
                            </div>
                        )
                    })
                }
            </div >
        </div >
    )
}

export { ChatAside }